import { useContext } from "react";
import { AppContext } from "../App";
import araratImage from "../assets/ararat.png";
import calipaImage from "../assets/calipa.png";
import beStoicImage from "../assets/beStoic.png";

const projects = [
  {
    id: "ararat",
    name: "Ararat Food & Stores Mobile App",
    description:
      "Purchase goods and food from multiple vendors with payments, shipping, and tracking built in.",
    type: "Mobile App",
    client: "Ararat Food & Stores",
    url: "https://araratstores.co.tz/",
    image: araratImage,
  },
  {
    id: "bestoic",
    name: "BeSTOIC - Personal Development & Well-being App",
    description:
      "A focused well-being app that helps users cultivate mindfulness, perseverance, and focus.",
    type: "Mobile App",
    client: "BY",
    url: "",
    image: beStoicImage,
  },
  {
    id: "calipa",
    name: "CAS Life Purpose Digital Platform - CALIPA",
    description:
      "Access books, courses, and podcasts on all your devices through one digital platform.",
    type: "Mobile App, Website",
    client: "CAS Life Purpose",
    url: "",
    image: calipaImage,
  }
];

export default function Projects() {
  const appContext = useContext(AppContext);

  function openProject(projectId) {
    appContext.navTo({
      item: "view",
      subItem: "project",
      extraItem: projectId,
    });
  }

  return (
    <section className="MainBodySection projects-showcase-section bg-light">
      <div className="container">
        <div className="row mb-5">
          <div className="col-lg-9">
            <h2 className="projects-showcase-title mb-3 text-secondary">Our Projects</h2>
            <p className="projects-showcase-subtitle mb-0 font-semi-bold">
              Clean digital products designed for real users and real business
              outcomes.
            </p>
          </div>
        </div>

        <div className="row g-4">
          {projects.map((project) => (
            <div key={project.id} className="col-md-6 col-lg-4">
              <button
                type="button"
                className="projects-showcase-card projects-showcase-card--plain"
                onClick={() => openProject(project.id)}
              >
                <div className="projects-showcase-image-wrap">
                  <img
                    src={project.image}
                    alt={project.name}
                    className="projects-showcase-image"
                  />
                  <div className="projects-showcase-overlay">
                    <div className="projects-showcase-content">
                      <p className="projects-showcase-type text-secondary font-bold">{project.type}</p>
                      <h3 className="projects-showcase-card-title">{project.name}</h3>
                      <p className="projects-showcase-card-copy">
                        {project.description}
                      </p>
                      <span className="projects-showcase-read-more">
                        Read more
                      </span>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          ))}

          <div className="col-md-12 text-center mt-5">
            <button className="btn btn-secondary btn-rounded btn-padded">
              View More Projects
            </button>
          </div>
        </div>

      </div>
    </section>
  );
}
